"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_leaflet_1 = require("react-leaflet");
var react_router_dom_1 = require("react-router-dom");
var leaflet_1 = require("leaflet");
require("leaflet/dist/leaflet.css");
// @ts-ignore
var marker_icon_png_1 = __importDefault(require("leaflet/dist/images/marker-icon.png"));
// @ts-ignore
var marker_icon_2x_png_1 = __importDefault(require("leaflet/dist/images/marker-icon-2x.png"));
// @ts-ignore
var marker_shadow_png_1 = __importDefault(require("leaflet/dist/images/marker-shadow.png"));
var icon = new leaflet_1.Icon({
    iconUrl: marker_icon_png_1.default,
    iconRetinaUrl: marker_icon_2x_png_1.default,
    iconSize: new leaflet_1.Point(25, 41),
    iconAnchor: new leaflet_1.Point(12, 41),
    popupAnchor: new leaflet_1.Point(1, -41),
    shadowUrl: marker_shadow_png_1.default,
});
var utils_1 = require("../../utils");
var ErrorBoundary_1 = __importDefault(require("../ErrorBoundary"));
var styles = {
    mapContainer: { height: 400 },
};
var MapPreview = react_1.default.memo(function (_a) {
    var layers = _a.layers, stations = _a.stations;
    var mapRef = (0, react_1.useRef)();
    var fittedBounds = (0, react_1.useRef)();
    var centre = [0, 0]; // Dummy centre - to be updated by add(...) event handler below
    return react_1.default.createElement(ErrorBoundary_1.default, null,
        react_1.default.createElement(react_leaflet_1.MapContainer, { ref: mapRef, center: centre, zoom: 14, style: styles.mapContainer },
            react_1.default.createElement(react_leaflet_1.TileLayer, { attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
            layers.filter(function (layer) { return layer.enabled; }).map(function (layer) {
                return react_1.default.createElement(react_leaflet_1.GeoJSON, { key: layer.id, data: layer.geojson, style: function (feature) {
                        var _a, _b;
                        return ({
                            color: (_b = (_a = feature.properties.stroke) !== null && _a !== void 0 ? _a : feature.properties.color) !== null && _b !== void 0 ? _b : "#000",
                        });
                    }, eventHandlers: {
                        add: function (e) {
                            // When we add the first layer to the map, we fit the bounds of the map to the bounding box of that layer.
                            // This is an imperfect method for multiple layers; in the future we could calculate the bounding box of
                            // all bounding boxes via getBounds() on each layer and then fitting at the end.
                            if (!mapRef.current)
                                return;
                            if (fittedBounds.current)
                                return;
                            mapRef.current.fitBounds(e.target.getBounds());
                            fittedBounds.current = true;
                        },
                    } });
            }),
            (stations !== null && stations !== void 0 ? stations : []).filter(function (station) { return station.enabled; }).map(function (station) {
                var t = (0, utils_1.transformCoords)(station.coordinates_utm);
                return react_1.default.createElement(react_leaflet_1.Marker, { icon: icon, position: [t.latitude, t.longitude], key: station.id },
                    react_1.default.createElement(react_leaflet_1.Popup, null,
                        react_1.default.createElement(react_router_dom_1.Link, { to: "/stations/detail/".concat(station.id) }, station.title)));
            })));
});
exports.default = MapPreview;
